export const CHROME_STORE_URL = "https://chrome.google.com/webstore/detail/timing71/pjdcehojcogjpilmeliklfddboeoogpd";

export const PAYPAL_DONATE_LINK = "https://www.paypal.com/donate/?business=VDM6XF682VSU6&no_recurring=0&item_name=Thanks+for+donating+and+helping+to+keep+Timing71+running%21&currency_code=GBP";
